module.exports = __webpack_public_path__ + "img/pay-circle.fc36f034.svg";